<template>
  <div id="footer">
    <div class="etw_footin">
      <div id="etw_bottom">
        <div class="row" style="align-items:flex-start">
          <div style="width:42%;padding:0 15px">
            <div class="f_logo">
              <router-link to="/">
                <div style="font-family:Oswald,sans-serif;font-weight:700;font-size:1.2rem;color:#fff">
                  Paper<span style="color:#E67E22">Stirrer</span>
                </div>
              </router-link>
            </div>
            <div class="quick_list">
              <router-link to="/">Home</router-link>
              <router-link to="/about">About Us</router-link>
              <router-link to="/products">Products</router-link>
              <router-link to="/contact">Contact</router-link>
            </div>
          </div>
          <div style="width:25%;padding:0 15px">
            <div class="footer webtitle">Products</div>
            <ul>
              <li v-for="cat in categories" :key="cat.id">
                <router-link :to="'/products/' + cat.slug">{{ cat.name }}</router-link>
              </li>
            </ul>
          </div>
          <div style="width:33%;padding:0 15px">
            <div class="home_contact">
              <div class="footer webtitle">Contact Us</div>
              <div class="cot_add">No. 9, Jinsha Road, Zhu Pingsha Village, Wangniudun Town, Dongguan City, Guangdong Province, China</div>
              <div class="cot_people">Sales Team</div>
              <div class="cot_email"><a href="mailto:linda@glopaper.com">linda@glopaper.com</a></div>
              <div class="cot_mobile"><a href="tel:+86-138-2578-2357">WhatsApp: +86-138-2578-2357</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footercop">
      <div>&copy; 2026 PaperStirrer.com. All Rights Reserved.</div>
    </div>
  </div>
</template>

<script>
import { getCategories } from '@/api/category'

export default {
  name: 'AppFooter',
  data() {
    return {
      categories: []
    }
  },
  created() {
    this.loadCategories()
  },
  methods: {
    async loadCategories() {
      try {
        const res = await getCategories()
        const data = res.data || res
        this.categories = Array.isArray(data) ? data.slice(0, 5) : []
      } catch (e) {
        this.categories = []
      }
    }
  }
}
</script>
